module.exports = __webpack_public_path__ + "img/ic_favorite.e1e22a6a.svg";